module.exports = "/_next/static/images/97b44f5affd3a4e102d94e1469ba5370-rewards-hosting@0.5x.png";